var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 57,
    viewBox: "0 0 64 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Barlow-SemiBold, Barlow",
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: 0.5
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.374,
    y: 41
  }, "ADD IMAGE")), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M32.12,29.33 C32.5866667,29.33 32.82,29.0966667 32.82,28.63 L32.82,28.63 L32.82,16.45 C32.82,16.2633333 32.9133333,16.17 33.1,16.17 L33.1,16.17 L45.63,16.17 C46.0966667,16.17 46.33,15.9366667 46.33,15.47 L46.33,15.47 L46.33,14.49 C46.33,14.0233333 46.0966667,13.79 45.63,13.79 L45.63,13.79 L33.1,13.79 C32.9133333,13.79 32.82,13.6966667 32.82,13.51 L32.82,13.51 L32.82,0.7 C32.82,0.233333333 32.5866667,0 32.12,0 L32.12,0 L31.14,0 C30.6733333,0 30.44,0.233333333 30.44,0.7 L30.44,0.7 L30.44,13.51 C30.44,13.6966667 30.3466667,13.79 30.16,13.79 L30.16,13.79 L17.7,13.79 C17.2333333,13.79 17,14.0233333 17,14.49 L17,14.49 L17,15.47 C17,15.9366667 17.2333333,16.17 17.7,16.17 L17.7,16.17 L30.16,16.17 C30.3466667,16.17 30.44,16.2633333 30.44,16.45 L30.44,16.45 L30.44,28.63 C30.44,29.0966667 30.6733333,29.33 31.14,29.33 L31.14,29.33 L32.12,29.33 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/add-image.0bce382f.svg";
export { ForwardRef as ReactComponent };